import React, { useEffect ,useState} from 'react'
import style from './Home.module.css'
import Navbar from './Navbar'
import Footer from './Footer'
import { useNavigate } from "react-router-dom";
import { FitnessCategory } from "../https/http";

const Home = () => {

  
  const [videos, setVideos] = useState([]);
  const navigate=useNavigate();
  // const getVideoName = (url) => {
  //   if (!url) return "Workout Video";
  //   return decodeURIComponent(url.split("/").pop().replace(".mp4", ""));
  // };


useEffect(() => {
    const fetchData = async () => {
      const res = await FitnessCategory();
console.log(res.data?.data?.videos,"data------")
      const categoryVideos = res.data?.data?.videos || [];
      setVideos(categoryVideos);
    };

    fetchData();
  }, []);




  return (
    <>
   <Navbar />

<div className={style.main_container}>  
  <div className={style.text_section}>
    <h2 className={style.heading1}>Invest time now to protect your future health.</h2>
    <h1 className={style.heading2}>one step to fitness</h1>
    <p className={style.para}>
      Build strength through consistent movement, balanced nutrition, and mindful yoga. 
      Every healthy choice boosts energy, improves focus, and supports long-term wellness, balance, and confidence.
    </p>
    <button className={style.btn}> Become a member</button>
  </div>
</div>
{/* service section */}

  <div className={style.health_images}>
    <h3 className={style.service_heading}>our Categories</h3>

    <div className={style.service_card}>
      <div className={style.food_image}></div>
      <p className={style.card_text}>Personalized nutrition guidance</p>
      <button
      className={style.card_btn}
      onClick={() => navigate("/Health Tips/3")}
    >Explore</button>
    </div>

    <div className={style.service_card}>
      <div className={style.gym_image}></div>
      <p className={style.card_text}>Strength & gym training programs</p>
      <button className={style.card_btn}onClick={() => navigate("/Exercise/2")}>Explore</button>
    </div>

    <div className={style.service_card}>
      <div className={style.yoga_image}></div>
      <p className={style.card_text}>Yoga for flexibility & calm mind</p>
      <button className={style.card_btn}onClick={() => navigate("/Yoga/5")}>Explore</button>
    </div>

  </div>
  {/* video section */}

  <div className={style.videos_section}>
  <h2 className={style.videos_heading}>Exercise Videos</h2>

  <div className={style.videos_container}>
    {videos.length > 0 ? (
      videos.map((category) => {
        const firstVideo = category.videos?.[0]; 

        if (!firstVideo) return null;

        return (
          <div
            className={style.video_card}
            key={category.id}
          >
            <video
              poster={firstVideo.video_thumbnail}
              src={firstVideo.video_src}
              controls
              preload="metadata"
              playsInline
              className={style.video_image}
            />

            {/* Category Name */}
            <p className={style.video_title}>
              {category.category}
            </p>

            <a
              href={firstVideo.video_src}
              target="_blank"
              rel="noreferrer"
            >
              <button className={style.video_btn}>
                Watch Now
              </button>
            </a>
          </div>
        );
      })
    ) : (
      <p className={style.no_data}>No videos available</p>
    )}
  </div>
</div>



<div className={style.values_section}>
  <h2>Our Fitness Philosophy</h2>
  <div className={style.values_grid}>
    
    <div>
      <h3>Active Living</h3>
      <p>We promote movement through fun and energetic aerobics and workout videos.</p>
    </div>

    <div>
      <h3>Healthy Body</h3>
      <p>Exercise programs designed to strengthen muscles and improve overall fitness.</p>
    </div>

    <div>
      <h3>Peaceful Mind</h3>
      <p>Yoga and breathing practices to reduce stress and enhance mental clarity.</p>
    </div>

    <div>
      <h3>Daily Wellness</h3>
      <p>Practical health and wellness tips to support a balanced and healthy lifestyle.</p>
    </div>

  </div>
</div>



<div className={style.text_content_section}>
  <div className={style.container_content}>

    <h2 className={style.content_heading}>Your Journey to Better Health Starts Here</h2>

    <p className={style.lead}>
      At <span className={style.brand}>One Step to Fitness</span>, we believe that true wellness is built through small, consistent actions.
      Every movement you make, every healthy choice, every mindful breath brings you closer to a stronger, more confident version of yourself.
      Our mission is to guide you through this journey with simple, sustainable steps that fit naturally into your lifestyle.
    </p>

    <div className={style.content_blocks}>

  <div className={style.block}>
    <h3>Move With Purpose</h3>
    <p>
      Every step you take shapes the strongest version of you. 
      Movement is not just exercise — it’s a promise you make to your future self.
    </p>
  </div>

  <div className={style.block}>
    <h3>Nourish Your Inner Strength</h3>
    <p>
      Your body thrives when you treat it with care. 
      A balanced meal, a mindful breath, and a calm mind can transform your entire day.
    </p>
  </div>

  <div className={style.block}>
    <h3>Consistency Creates Change</h3>
    <p>
      Growth happens in the small moments you show up for yourself. 
      Stay committed, stay patient — the results will follow.
    </p>
  </div>
</div>
</div>

</div>
 

<Footer/>
  </>
  )
}

export default Home